/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v7.2.1. DO NOT EDIT. DO NOT COMMIT.

import StringMetricType from '@mozilla/glean/private/metrics/string';

/**
 * The name of the event
 *
 * Generated from `event.name`.
 */
export const name = new StringMetricType({
  category: 'event',
  name: 'name',
  sendInPings: ['accounts-events'],
  lifetime: 'ping',
  disabled: false,
});
